<template>
  <BaseModule
    v-bind="$props"
    class="container video-window"
    data-module="video-window"
  >
    <header
      v-if="title || text"
      class="header base-title-fontsize"
    >
      <component
        :is="titleTag"
        v-if="title"
        class="tit tit-g"
        :style="{ fontWeight: titleWeight }"
      >
        {{ title }}
      </component>
      <div
        v-if="text"
        class="txt"
        v-html="text"
      ></div>
    </header>
    <div class="aspect-ratio-parent">
      <div class="video-wrapper aspect-ratio-child">
        <div
          v-show="!showVideo"
          class="thumbnail"
        >
          <LImage
            :src="image"
            alt="Thumb do vídeo"
          />
          <div
            class="play-button"
            @click="play()"
          >
            <svg
              width="21"
              height="24"
              viewBox="0 0 20 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.52637 19.3542C1.52637 20.925 3.25426 21.8827 4.58636 21.0502L4.05636 20.2022L4.58636 21.0502L17.6154 12.907C18.8687 12.1237 18.8687 10.2984 17.6154 9.51504L4.58636 1.37192C3.25427 0.539361 1.52637 1.49705 1.52637 3.06792V19.3542Z"
              />
            </svg>
          </div>
          <div
            v-if="thumbText"
            class="thumb-text"
          >
            {{ thumbText }}
          </div>
        </div>
        <div
          v-show="showVideo"
          class="video"
        >
          <iframe
            :src="
              youtubeEmbed({
                url: linkVideo,
                controls: !hideYoutubeControls,
                autoplay: showVideo,
                loop: true,
              })
            "
            frameborder="0"
            allowfullscreen
            allow="autoplay"
          >
          </iframe>
        </div>
      </div>
    </div>
  </BaseModule>
</template>

<script>
import base from '@/mixins/base';
import { youtubeEmbed } from '@/helpers/youtube';
import BaseModule from './generic/BaseModule.vue';

export default {
  name: 'VideoWindow',
  components: {
    BaseModule,
  },
  mixins: [base],
  inheritAttrs: false,
  props: {
    ...BaseModule.props,
    text: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    thumbText: {
      type: String,
      default: '',
    },
    linkVideo: {
      type: Object,
      default: () => ({
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      }),
    },
    hideYoutubeControls: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showVideo: false,
    };
  },
  methods: {
    play() {
      this.showVideo = true;
    },
    youtubeEmbed,
  },
  metadata: {
    extends: [BaseModule.metadata],
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'text',
            fields: [
              {
                name: 'text',
                type: 'Html',
                label: 'Texto superior',
                wrapWithParagraph: false,
              },
            ],
            toRemove: ['subtitle'],
          },
          {
            name: 'video',
            label: 'Conteúdo',
            fields: [
              {
                name: 'image',
                type: 'ImageFile',
                maxWidth: 960,
                label: 'Thumbnail do vídeo',
              },
              {
                name: 'thumbText',
                type: 'ShortText',
                label: 'Descrição do vídeo',
              },
              {
                name: 'linkVideo',
                type: 'Url',
                label: 'URL do vídeo',
                availableTypes: ['externalLink'],
                allowNewTab: false,
                validation: {
                  presence: {
                    allowEmpty: false,
                    message: 'Insira uma URL para o vídeo',
                  },
                },
              },
              {
                name: 'hideYoutubeControls',
                type: 'Checkbox',
                label: 'Ocultar controles de vídeo',
              },
            ],
          },
        ],
      },
      {
        name: 'appearance',
        groups: [
          {
            name: 'colors',
            toRemove: ['buttonTextColor'],
          },
        ],
      },
    ],
  },
};
</script>

<style lang="scss">
.video-window {
  &.container {
    max-width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    padding-top: var(--padding-top);
    padding-bottom: var(--padding-bottom);

    @include media-breakpoint-down(lg) {
      padding-left: 5%;
      padding-right: 5%;
      padding-top: var(--padding-top-mobile);
      padding-bottom: var(--padding-bottom-mobile);
    }
  }

  .header {
    text-align: center;
  }

  .aspect-ratio-parent {
    padding-top: 56.25%;
    position: relative;

    @include media-breakpoint-down(sm) {
      padding-top: 100%;
    }

    .aspect-ratio-child {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  .video-wrapper {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;

    .thumbnail {
      position: relative;
      width: 100%;
      height: 100%;

      .play-button {
        cursor: pointer;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 80px;
        height: 80px;
        border: solid 2px var(--button-color, #fff);
        border-radius: 28px;
        display: flex;
        backdrop-filter: blur(10px);

        svg {
          stroke: var(--button-color, #fff);
          stroke-width: 2;
          stroke-linecap: round;
          stroke-linejoin: round;
          margin: auto;
          padding: 1px 0 0 1px;
        }

        @include media-breakpoint-down(lg) {
          width: 50px;
          height: 50px;
          border-radius: 16px;
        }
      }

      .thumb-text {
        position: absolute;
        width: 100%;
        text-align: center;
        bottom: 0;
        color: var(--button-color, #fff);
        padding: 36px 10px;
        font-size: 22px;
        font-weight: 600;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));

        @include media-breakpoint-down(sm) {
          padding: 20px 10px;
          font-size: 18px;
        }
      }
    }
    .video {
      width: 100%;
      height: 100%;

      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
